module.exports = __webpack_public_path__ + "static/media/delete_icon.29229a8a.svg";